/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBCOUNTRY = {
    CapeVerde: 'CV',
    Congo: 'CG',
    CongoTheDemocraticRepublicOfThe: 'CD',
    CteDivoire: 'CI',
    Croatia: 'HR',
    CzechRepublic: 'CZ',
    Swaziland: 'SZ',
    FalklandIslands: 'FK',
    HeardIslandAndMcdonaldIslands: 'HM',
    VaticanCityState: 'VA',
    IslamicRepublicOfIran: 'IR',
    DemocraticPeoplesRepublicOfKorea: 'KP',
    RepublicOfKorea: 'KR',
    LaoPeoplesDemocraticRepublic: 'LA',
    TheFormerYugoslavRepublicOfMacedonia: 'MK',
    FederatedStatesOfMicronesia: 'FM',
    Moldova: 'MD',
    Myanmar: 'MM',
    Runion: 'RE',
    SaintHelena: 'SH',
    SaintMartin: 'MF',
    Slovakia: 'SK',
    SvalbardAndJanMayen: 'SJ',
    SyrianArabRepublic: 'SY',
    TaiwanRoc: 'TW',
    UnitedRepublicOfTanzania: 'TZ',
    UnitedStates: 'US',
    Vietnam: 'VN',
    VirginIslandsBritish: 'VG',
    VirginIslandsUs: 'VI',
    WallisAndFutuna: 'WF',
    PalestinianTerritoryOccupied: 'PS',
    AlandIslands: 'AX',
    Antarctica: 'AQ',
    IsleOfMan: 'IM',
    Hungary: 'HU',
    Denmark: 'DK',
    CaymanIslands: 'KY',
    Botswana: 'BW',
    Ethiopia: 'ET',
    Angola: 'AO',
    Bulgaria: 'BG',
    Gabon: 'GA',
    Comoros: 'KM',
    Tunisia: 'TN',
    Djibouti: 'DJ',
    Liechtenstein: 'LI',
    Togo: 'TG',
    Spain: 'ES',
    SierraLeone: 'SL',
    Paraguay: 'PY',
    Benin: 'BJ',
    Seychelles: 'SC',
    SouthAfrica: 'ZA',
    Kuwait: 'KW',
    ElSalvador: 'SV',
    EquatorialGuinea: 'GQ',
    SaudiArabia: 'SA',
    Uruguay: 'UY',
    SouthGeorgiaAndTheSouthSandwichIslands: 'GS',
    Lithuania: 'LT',
    BruneiDarussalam: 'BN',
    MarshallIslands: 'MH',
    Jordan: 'JO',
    Lebanon: 'LB',
    Italy: 'IT',
    Liberia: 'LR',
    CookIslands: 'CK',
    Gibraltar: 'GI',
    BosniaAndHerzegovina: 'BA',
    Malta: 'MT',
    FrenchGuiana: 'GF',
    Afghanistan: 'AF',
    Japan: 'JP',
    BritishIndianOceanTerritory: 'IO',
    Tonga: 'TO',
    Latvia: 'LV',
    Luxembourg: 'LU',
    TrinidadAndTobago: 'TT',
    Australia: 'AU',
    Jersey: 'JE',
    NewCaledonia: 'NC',
    Poland: 'PL',
    BurkinaFaso: 'BF',
    BonaireSintEustatiusAndSaba: 'BQ',
    Tajikistan: 'TJ',
    Chile: 'CL',
    Mauritius: 'MU',
    Niger: 'NE',
    Algeria: 'DZ',
    Slovenia: 'SI',
    Iceland: 'IS',
    Gambia: 'GM',
    Montserrat: 'MS',
    Palau: 'PW',
    Belize: 'BZ',
    Barbados: 'BB',
    Azerbaijan: 'AZ',
    Austria: 'AT',
    CocosKeelingIslands: 'CC',
    Romania: 'RO',
    Anguilla: 'AI',
    Guernsey: 'GG',
    CostaRica: 'CR',
    SolomonIslands: 'SB',
    Rwanda: 'RW',
    Pakistan: 'PK',
    Suriname: 'SR',
    Mexico: 'MX',
    WesternSahara: 'EH',
    Guam: 'GU',
    Eritrea: 'ER',
    Qatar: 'QA',
    Tuvalu: 'TV',
    Samoa: 'WS',
    PuertoRico: 'PR',
    NewZealand: 'NZ',
    Chad: 'TD',
    Mali: 'ML',
    Tokelau: 'TK',
    GuineaBissau: 'GW',
    Mayotte: 'YT',
    Peru: 'PE',
    Madagascar: 'MG',
    AmericanSamoa: 'AS',
    Brazil: 'BR',
    Iraq: 'IQ',
    Belarus: 'BY',
    Bahrain: 'BH',
    Senegal: 'SN',
    LibyanArabJamahiriya: 'LY',
    PapuaNewGuinea: 'PG',
    Kiribati: 'KI',
    Cambodia: 'KH',
    Panama: 'PA',
    Ireland: 'IE',
    FrenchPolynesia: 'PF',
    Kenya: 'KE',
    SaintKittsAndNevis: 'KN',
    Turkey: 'TR',
    Philippines: 'PH',
    SaoTomeAndPrincipe: 'ST',
    Germany: 'DE',
    FaroeIslands: 'FO',
    Switzerland: 'CH',
    Turkmenistan: 'TM',
    Bermuda: 'BM',
    Vanuatu: 'VU',
    Estonia: 'EE',
    Uzbekistan: 'UZ',
    Namibia: 'NA',
    Monaco: 'MC',
    Bangladesh: 'BD',
    Belgium: 'BE',
    Niue: 'NU',
    Singapore: 'SG',
    Serbia: 'RS',
    Armenia: 'AM',
    Sweden: 'SE',
    Andorra: 'AD',
    Bhutan: 'BT',
    Nicaragua: 'NI',
    Cameroon: 'CM',
    Guinea: 'GN',
    Jamaica: 'JM',
    ChristmasIsland: 'CX',
    Nepal: 'NP',
    DominicanRepublic: 'DO',
    Kazakhstan: 'KZ',
    SaintBarthlemy: 'BL',
    SanMarino: 'SM',
    India: 'IN',
    Zambia: 'ZM',
    Maldives: 'MV',
    SaintLucia: 'LC',
    Dominica: 'DM',
    Yemen: 'YE',
    Bahamas: 'BS',
    Burundi: 'BI',
    Guyana: 'GY',
    Indonesia: 'ID',
    Finland: 'FI',
    BouvetIsland: 'BV',
    Malawi: 'MW',
    Ukraine: 'UA',
    Uganda: 'UG',
    Haiti: 'HT',
    Nigeria: 'NG',
    TimorLeste: 'TL',
    Ecuador: 'EC',
    Zimbabwe: 'ZW',
    China: 'CN',
    Israel: 'IL',
    Aruba: 'AW',
    Somalia: 'SO',
    France: 'FR',
    Oman: 'OM',
    UnitedArabEmirates: 'AE',
    Ghana: 'GH',
    NorthernMarianaIslands: 'MP',
    Martinique: 'MQ',
    SriLanka: 'LK',
    Cuba: 'CU',
    Argentina: 'AR',
    Morocco: 'MA',
    FrenchSouthernTerritories: 'TF',
    Macao: 'MO',
    Malaysia: 'MY',
    Egypt: 'EG',
    Cyprus: 'CY',
    UnitedStatesMinorOutlyingIslands: 'UM',
    Albania: 'AL',
    Honduras: 'HN',
    TurksAndCaicosIslands: 'TC',
    Grenada: 'GD',
    Netherlands: 'NL',
    Norway: 'NO',
    Georgia: 'GE',
    Portugal: 'PT',
    Lesotho: 'LS',
    Mongolia: 'MN',
    AntiguaAndBarbuda: 'AG',
    CentralAfricanRepublic: 'CF',
    RussianFederation: 'RU',
    Sudan: 'SD',
    Colombia: 'CO',
    Nauru: 'NR',
    Guadeloupe: 'GP',
    Thailand: 'TH',
    SintMaartenDutchPart: 'SX',
    Mauritania: 'MR',
    Greenland: 'GL',
    Fiji: 'FJ',
    Mozambique: 'MZ',
    SaintPierreAndMiquelon: 'PM',
    Montenegro: 'ME',
    HongKong: 'HK',
    NorfolkIsland: 'NF',
    Kyrgyzstan: 'KG',
    Greece: 'GR',
    SaintVincentAndTheGrenadines: 'VC',
    Bolivia: 'BO',
    Pitcairn: 'PN',
    Venezuela: 'VE',
    Canada: 'CA',
    UnitedKingdom: 'GB',
    Guatemala: 'GT',
    Curaao: 'CW',
    SouthSudan: 'SS'
} as const;
export type GHUBCOUNTRY = typeof GHUBCOUNTRY[keyof typeof GHUBCOUNTRY];


export function GHUBCOUNTRYFromJSON(json: any): GHUBCOUNTRY {
    return GHUBCOUNTRYFromJSONTyped(json, false);
}

export function GHUBCOUNTRYFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBCOUNTRY {
    return json as GHUBCOUNTRY;
}

export function GHUBCOUNTRYToJSON(value?: GHUBCOUNTRY | null): any {
    return value as any;
}

